import { render } from "./People.vue?vue&type=template&id=002085ec&scoped=true"
import script from "./People.vue?vue&type=script&lang=js"
export * from "./People.vue?vue&type=script&lang=js"

import "./People.vue?vue&type=style&index=0&id=002085ec&scoped=true&language=scss&lang=css"
script.render = render
script.__scopeId = "data-v-002085ec"

export default script